import React from "react"

const towerMap = new Map<string, string>([
  [
    "Great St Mary's",
    "https://www.google.co.uk/maps/place/Great+St+Mary's+Church/@52.2053187,0.1160404,17z/data=!3m1!4b1!4m5!3m4!1s0x47d870bec1546a85:0x8e6bef904755f0c2!8m2!3d52.2053154!4d0.1182291",
  ],
  [
    "St Bene't's",
    "https://www.google.co.uk/maps/place/St+Bene%E2%80%99t%E2%80%99s+Church/@52.2036683,0.1160083,17z/data=!3m1!4b1!4m5!3m4!1s0x47d870bd1036c471:0x854aafc5b3ea36ad!8m2!3d52.203665!4d0.118197",
  ],
  [
    "St Andrew the Great",
    "https://www.google.co.uk/maps/place/St+Andrew+the+Great+Church/@52.2050267,0.119616,17z/data=!3m1!4b1!4m5!3m4!1s0x47d87097749024c3:0xf6368fa47199219c!8m2!3d52.2050234!4d0.1218047",
  ],
  [
    "Cambridge Army Reserve Centre",
    "https://www.google.com/maps/place/Army+Reserve+Centre/@52.1852335,0.1571861,17z/data=!3m1!4b1!4m5!3m4!1s0x47d87bea8c74491b:0x44f94b828a90b743!8m2!3d52.1851974!4d0.1596144?hl=en"
  ],
])
interface LocationProps {
  tower: string
}
export const TowerLocation: React.FC<LocationProps> = props => (
  <a href={towerMap.get(props.tower)}>{props.children || props.tower}</a>
)
